import {
    BooleanField,
    Datagrid,
    DeleteWithConfirmButton,
    List,
    TextField
} from "react-admin";

export const YoutubeVideoList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <BooleanField source="isActive" />
        <TextField source="id" />
        <TextField source="title" />
        <TextField source="thumbnailUrl" />
        <TextField source="youtubeUrl" />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};
